import { Injectable } from "@angular/core";
// import { Store } from "@ngrx/store";
// import { CheckoutApiService } from "app/checkout/_services/checkout-api.service";
// import { NbnCompositeModel } from "app/qualification/_store/nbn-qualification/nbn-qualification.model";
// import { nbnCompositeAddressSelector } from "app/qualification/_store/nbn-qualification/nbn-qualification.selectors";
// import { Zeus } from "app/_core/services/models/zeus.models";
import { of, Observable, BehaviorSubject } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class BoboPaymentService {
	public paymentReference$: BehaviorSubject<any>;
	private paymentSmsRef: any;
	constructor() {
        this.paymentReference$ = new BehaviorSubject<any>(undefined);
    }
    
    set paymentSmsReference(ref: any) {
		this.paymentSmsRef = ref;
		this.paymentReference$.next(ref);
	}

}
